export default class VehicleLot {
  constructor (options = {}) {
    this.model = 'VehicleLot'

    this.id = options.id
    this.name = options.name
    this.description = options.description

    // Contact and details
    this.email = options.email
    this.timezone = options.timezone
    this.phone = options.phone
    this.phone_secondary = options.phone_secondary
    this.available_times = options.available_times

    // Notes and settings
    this.notes = options.notes || {}
    this.settings = options.settings || {}

    // Address and coords
    this.coords = options.coords
    this.street_1 = options.street_1
    this.street_2 = options.street_2
    this.city = options.city
    this.state = options.state
    this.zip = options.zip
    this.postal_code = options.postal_code
    this.country = options.country

    // Status
    this.vehicle_lot_status = options.vehicle_lot_status

    // Auditing
    this.created_at = options.created_at
    this.created_by = options.created_by
    this.updated_at = options.updated_at
  }
}
